// extracted by mini-css-extract-plugin
export default {"container":"TableTwoCellWithIcons_container__cStz9","icons":"TableTwoCellWithIcons_icons__8pRVh","text":"TableTwoCellWithIcons_text__zk8yS"};